import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import "../../design/assets-rangeDate/styles/calendar.scss";
import func, { swalAlert } from "../../services/functions";
import mainAxios from "../../services/mainAxios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faFile,
    faFilter,
    faChevronUp,
    faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import Loader from "../Layout/Loader";
import { useAppContext, usePersistedState } from "../../AppContext";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import selectStyle, { multiSelectHeaderStyle } from "../../design/selectStyle";
import generatePurchasesColumns from "./columns/generatePurchasesColumns";
import "../../design/custom.scss";
import { purchaseAction } from "./columns/PurchaseAction";
import PopOver from "../global/PopOver";
import SelectOptionWithInfo from "./FunctionalityHeaderOption";
import DateRange from "../global/DateRange";
import AlertCertificate from "../global/AlertCertificate";
import AlertSubscription from "../global/AlertSubscription";
import { Column } from "primereact/column";
import PrimeTable, { parseFilterParams } from "../PrimeTable/PrimeTable";
import CellInput from "../global/CellInput";
import { globalFilterStatisticCard } from "../global/StatisticsCards";
import CisMessage from "../global/CisMessage";
import { Dialog } from "primereact/dialog";
import { defaultTableRows } from "../../services/data";
import ExportCsvMultiple from "../global/ExporCsvMultiple";
import { Oval, Preloader } from "../global/Preloader";
import { DisableLayout } from "../Layout/DisableLayout";
import useShowInvoicePdf from "../global/useShowInvoicePdf";
import { usePurchaseInvoiceStore } from "../../store/PurchaseInvoiceStore";
import useGeneratePurchasesColumns from "./columns/generatePurchasesColumns";
import { allTcrFn, cisStatusOptionsFn, currencyOptionsFn, internalStatusOptionsFn, otherOptionsFn, priorityOptionsFn, tcrListFn, uIOptionsFn } from "./Utils";
import EditAddSupplies from "../Setup/Contacts/EditAddContact";
import useDownloadPurchInvoices from "./useDownloadPurchInvoices";
import useApprovePurchInvoices from "./useApprovePurchInvoices";
import usePaymentOrderMultiselect from "./usePaymentOrderMultiselect"; 
import { openBankingVisibility } from "../OpenBanking/OpenBankingUtils";

const moment = require("moment");
const PurchasesNew = () => {
    const { t,i18n } = useTranslation("translations");


    const {
        user: [user],
        selectedCompany: [selectedCompany],
        purchasesColumns: [purchasesColumns, setPurchasesColumns],
        company: [fullCompany],
        // dates: [dates, setDates],
        unitsOfMeasure,
        

    } = useAppContext();

    const company = user.companiesRights.find(
        (company) => company.id === parseInt(selectedCompany)
    );

    const manualWsEnabled = fullCompany?.companyAttributes?.find(a => a?.attribute?.param === "manualWs")?.value !== "no";
    const [statistics, setStatistics] = useState(null);

    const [refreshGrid, setRefreshGrid] = useState(false)
    const [cisLoading, setCisLoading] = useState(false)
    const [filtersCollapsed, setFiltersCollapsed] = usePersistedState(false, "purchasesFiltersCollapsed")
    const [filterDialogVisible, setFilterDialogVisible] = useState(false)
    const [headerCheckboxMode, setHeaderCheckboxMode] = useState("none");

    const [persistedRowPerPage, setPersistedRowPerPage,] = usePersistedState(
        10,
        "rowsPerPage"
    );

    const {
        filters,
        setFilters,
        defaultFilters,
        filterParams,
        persistedData,
        setPersistedData,
        businessUnitCodes,
        businessUnitSelected,
    } = usePurchaseInvoiceStore()

    const filterCount = useMemo(() => {
        let count = 0;
        const params = filters?.params;
        if (defaultFilters && params) {
            Object.keys(params).forEach(key => {
                const value = params[key];
                const isDefault = JSON.stringify(value) === JSON.stringify(defaultFilters?.params?.[key]);
                if (!isDefault && value != null) {
                    Array.isArray(value) ? count += value.length : count++;
                }
            });
        }
        return count;
    }, [defaultFilters, filters]);

    const [invoices, setInvoices] = useState(null);
    const [dataFrom, setDataFrom] = useState("DOC");
    const [checkUnknownBussiness,setCheckUknownBussiness]=useState(false)

    const filterLikeValues=false

    const [contactModal,setContactModal]=useState({visible:false,invoice:null})

    const defaultExpand = {
        invoiceItems: [],
        expandedRows: null,
        loadingInvoiceItems: false,
        expandedInvoiceRows: [],
        expandedInvoiceData: null,
        loadingInvoiceData: false
      }
      const [expanded, setExpanded] = useState(defaultExpand)

    const tcrList = React.useCallback((businessUnitCode, showSelectValue = true) => {
        return  tcrListFn(businessUnitCode,businessUnitSelected,company)
    }, [businessUnitSelected, company.branches])

    const allTcr = useMemo(()=>{
        return allTcrFn(company)
    },[selectedCompany,company.branches])


    const [uIType, setUIType] = useState({
        value: "eic",
        label: "EIC",
        uidValue: "",
    });

    const [loading, setLoading] = useState(false);


    const defaultSortCriteria={
        field: "recordDateTime",
        direction: "DESC"
    }

    const [tableRows, setTableRows] = useState({
        ...defaultTableRows,
        rowsPerPage:persistedRowPerPage,
        sortCriteria:defaultSortCriteria
    });
    const [invoicesForCSV, setInvoicesForCSV] = useState([]);

    const getFilteredResults = (
        {
            data,
            pageSize = (persistedRowPerPage?? defaultTableRows.rowsPerPage),
            page = defaultTableRows.currentPage,
            dataFromCis = false,
            getInvoicesForCVS = false,
            buReset = false,
            approvedInvoices,
            status,
            sortCriteria = [ defaultSortCriteria ],
            returnData=false
        }
    ) => {
        let filterData = data ? { ...data } : { ...filters };
        if (!getInvoicesForCVS && !approvedInvoices && !returnData) setLoading(true);
        if (invoicesForCSV.length > 0) setInvoicesForCSV([]);
        if (!data) {
            filterData.params = {
                ...filterData.params,
                dataFrom: dataFromCis ? "CIS" : "DB",
                checkUnknownBusiness: dataFromCis
                    ? filterData.params.checkUnknownBusiness
                    : false,
            };

            setDataFrom(dataFromCis ? "CIS" : "DB");

            if (uIType?.uidValue) {
                let val;
                if (dataFromCis) {
                    val = uIType.uidValue;
                    if (
                        uIType.value === "eic" &&
                        !new RegExp(
                            /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/
                        ).test(val)
                    ) {
                        toast.warning(
                            "Incorrect Pattern for type " + uIType.value.toUpperCase(),
                            {
                                containerId: "all_toast",
                            }
                        );
                    } else {
                        filterData.params = {
                            ...filterData.params,
                            [uIType.value]: val,
                        };
                    }
                } else {
                    //concat with <L> in case of DB
                    val = uIType.uidValue;
                    filterData.params = {
                        ...filterData.params,
                        [uIType.value]: val,
                    };
                }
            }
        }
        let purchaseUnit = ""
        if (filterData.params.purchaseUnit.length == 0 && buReset) {
            purchaseUnit = ""
        } else if (filterData.params.purchaseUnit.length == 0) {
            purchaseUnit = tcrList(null, false).map(tcr => tcr.value).join(",")
        } else {
            purchaseUnit = filterData.params.purchaseUnit.join(",")
        }

        const endpoint = approvedInvoices ? "endpoint/v2/changePurchaseInvoicesStatusInGroup" : "endpoint/v2/getMyPurchases"
        let reqParams = {}

        filterData= parseFilterParams({filters:filterData,columns,likeValues:filterLikeValues})

        Object.keys(filterData.params).forEach(param => {
            if (filterData.params[param] != "" && param != "purchaseUnit") {
                if (param === "priority" || param === "currency" || param === "internalStatus" || param === "purchaseStatus") {
                    reqParams[param] = filterData.params[param].join(",");
                    // } else if (param === "checkUnknownBusiness"){
                    //   reqParams.checkUnknownBusiness = filterParams.checkUnknownBusiness
                } else {
                    reqParams[param] = filterData.params[param]
                }
            } else if (param === "checkUnknownBusiness") {
                reqParams.checkUnknownBusiness = filterParams.checkUnknownBusiness
            }
        })

        if (purchaseUnit !== "") {
            reqParams.purchaseUnit = purchaseUnit;
        }


        return mainAxios
            .post(endpoint, {
                fromDate:filterData.fromDate,
                toDate:filterData.toDate,
                value: approvedInvoices ? approvedInvoices?.join(",") : null,
                ...(status ? { status } : {}),
                params: {
                    ...reqParams
                },
                pagination: getInvoicesForCVS
                    ? null
                    : {
                        pageSize: pageSize,
                        pageNumber: page,
                    },
                nuis: user.companiesRights.find(
                    (company) => company.id === parseInt(selectedCompany)
                )?.nuis,
                sortCriteria
            })
            .then((res) => {
                if (!getInvoicesForCVS && !approvedInvoices && !returnData ) setLoading(false);
                if (res?.data?.status) {
                    if(returnData) return res.data.content
                    if (getInvoicesForCVS) {
                        setInvoicesForCSV(res.data.content);
                    } else {
                        setInvoices(res.data.content);
                        setTableRows((tableRows)=>({
                            ...tableRows,
                            totalRows: res?.data?.totalSize,
                          }));
                    }


                    return true;
                }
                return false;

            })
            .catch((err) => {
                if (!getInvoicesForCVS && !approvedInvoices && !returnData) setLoading(false);

                return false;
            });
    };
    
    const downloadByPeriod = (
        {
            data,
            pageSize = (persistedRowPerPage?? defaultTableRows.rowsPerPage),
            page = defaultTableRows.currentPage,
            dataFromCis = false,
            getInvoicesForCVS = false,
            buReset = false,
            approvedInvoices,
            status,
            sortCriteria = [ defaultSortCriteria ],
            returnData=false
        }
    ) => {
        const filterData = data ? { ...data } : { ...filters };
        // The backend runs the CIS fetch in the background and replies immediately; the grid reloads when its notification arrives,
        // so don't lock the layout while waiting.
        setCisLoading(true)
        if (invoicesForCSV.length > 0) setInvoicesForCSV([]);
        if (!data) {
            filterData.params = {
                ...filterData.params,
                dataFrom: dataFromCis ? "CIS" : "DB",
                checkUnknownBusiness: dataFromCis
                    ? filterData.params.checkUnknownBusiness
                    : false,
            };

            setDataFrom(dataFromCis ? "CIS" : "DB");

            if (uIType?.uidValue) {
                let val;
                if (dataFromCis) {
                    val = uIType.uidValue;
                    if (
                        uIType.value === "eic" &&
                        !new RegExp(
                            /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/
                        ).test(val)
                    ) {
                        toast.warning(
                            "Incorrect Pattern for type " + uIType.value.toUpperCase(),
                            {
                                containerId: "all_toast",
                            }
                        );
                    } else {
                        filterData.params = {
                            ...filterData.params,
                            [uIType.value]: val,
                        };
                    }
                } else {
                    //concat with <L> in case of DB
                    val = uIType.uidValue;
                    filterData.params = {
                        ...filterData.params,
                        [uIType.value]: val,
                    };
                }
            }
        }
        let purchaseUnit = ""
        if (filterData.params.purchaseUnit.length == 0 && buReset) {
            purchaseUnit = ""
        } else if (filterData.params.purchaseUnit.length == 0) {
            purchaseUnit = tcrList(null, false).map(tcr => tcr.value).join(",")
        } else {
            purchaseUnit = filterData.params.purchaseUnit.join(",")
        }

        const endpoint = "apiEndpoint/apiExtractAllPurchaseInvoicesWithDates"
        let reqParams = {}
        Object.keys(filterData.params).forEach(param => {
            if (filterData.params[param] != "" && param != "purchaseUnit") {
                if (param === "priority" || param === "currency" || param === "internalStatus" || param === "purchaseStatus") {
                    reqParams[param] = filterData.params[param].join(",");
                    // } else if (param === "checkUnknownBusiness"){
                    //   reqParams.checkUnknownBusiness = filterParams.checkUnknownBusiness
                } else {
                    reqParams[param] = filterData.params[param]
                }
            } else if (param === "checkUnknownBusiness") {
                reqParams.checkUnknownBusiness = filterParams.checkUnknownBusiness
            }
        })

        if (purchaseUnit !== "") {
            reqParams.purchaseUnit = purchaseUnit;
        }

        return mainAxios
            .post(endpoint, {
                ...filterData,
                value: approvedInvoices ? approvedInvoices?.join(",") : null,
                ...(status ? { status } : {}),
                params: {
                    ...reqParams
                },
                pagination: getInvoicesForCVS
                    ? null
                    : {
                        pageSize: pageSize,
                        pageNumber: page,
                    },
                nuis: user.companiesRights.find(
                    (company) => company.id === parseInt(selectedCompany)
                )?.nuis,
                sortCriteria
            })
            .then((res) => {
                if(res.data.status){
                    toast.info(t("invoice.invoicesFromCisLoading"), {
                        containerId: "all_toast",
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                }
            })
            .catch(() => false)
            .finally(() => setCisLoading(false));
    };

    useEffect(() => {
        if (!(filters?.fromDate && filters?.toDate) || !fullCompany) {
            return;
        }
        let endpoint = persistedData?.businessUnitCode
            ? "/endpoint/v2/reports/mypurchase/branch/aggregate"
            : "/endpoint/v2/reports/mypurchase/company/aggregate";
        mainAxios
            .post(endpoint, {
                object: "GetMyPurchaseCashDepositStatisticsAnalytics",
                fromDate: moment(filters?.fromDate).format("YYYY-MM-DD"),
                toDate: moment(filters?.toDate).format("YYYY-MM-DD"),
                ...(persistedData?.businessUnitCode
                    ? { params: { businessUnitCode: persistedData?.businessUnitCode } }
                    : {}),
            })
            .then((res) => {
                if (res?.data?.status) {
                    let getStatistics = calculateStatistics(res.data.content);
                    setStatistics(getStatistics);
                }
            });
    }, [filters?.fromDate, filters?.toDate, persistedData?.businessUnitCode,filters?.reloadData ]);

    const calculateStatistics = (data) => {
        if (data?.length > 0) {
            const { id, businessUnitCode, company, recordDate, ...rest } = data[0];
            let stats = {};
            Object.keys(rest).forEach((key) => {
                stats[key] = data.reduce((sum, tcrStat) => sum + tcrStat[key], 0);
            });
            return stats;
        }
        return [];
    };

    useEffect(() => {
        if (!(filters?.fromDate && filters?.toDate) || !fullCompany) {
            return;
        }
        getFilteredResults({ data: filters });
    }, [refreshGrid ,filters?.reloadData,filters?.fromDate, filters?.toDate]);

    // The CIS fetch runs in the background; reload the grid and counters when its notification arrives
    useEffect(() => {
        const onNotification = (e) => {
            const { type, title } = e.detail ?? {};
            if (type === "MY_PURCHASE" && title === "Get purchase invoices from CIS") {
                setFilters((state) => ({ ...state, reloadData: !state.reloadData }));
            }
        };
        window.addEventListener("app-notification", onNotification);
        return () => window.removeEventListener("app-notification", onNotification);
    }, []);








  const unitofMeasureBody = useCallback((row)=>{const uom = unitsOfMeasure.find(uom=>uom.englishName===row.unitOfMeasure) ; if(uom){ return i18n.language == "alb" ?   uom?.albanianName: uom?.englishName} return row?.unitOfMeasure ?? ""},[unitsOfMeasure,i18n])

    const expandedColumns = [
        {
          field: "",
          header: "",
          style: { minWidth: 40,maxWidth:40 },
        },
        {
          field: "itemCode",
          header: t("books.itemCode"),
          style: { minWidth: 170,maxWidth:170 },
          sortable: true,
        },
        {
          field: "itemName",
          header: t("books.itemName"),
          style: { minWidth: 170,maxWidth:170 },
          sortable: true,
        },
        {
          field: "unitOfMeasure",
          header: t("books.unitOfMeasure"),
          style: { minWidth: 120,maxWidth:120 },
          body:unitofMeasureBody
        },
        {
          field: "itemQuantity",
          header: t("books.itemQuantity"),
          style: { minWidth: 90,maxWidth:90 },
        },
        {
          field: "unitPriceBefore",
          header: t("books.unitPriceBefore"),
          style: { minWidth: 150,maxWidth:150 },
          body: (row) =>
            func.getFormattedMoneyValue(row?.unitPriceBefore ?? 0),
          align: "right"
        },
        {
          field: "unitPriceAfter",
          header: t("books.unitPriceAfter"),
          style: { minWidth: 150,maxWidth:150 },
          body: (row) =>
            func.getFormattedMoneyValue(row?.unitPriceAfter ?? 0),
          align: "right"
        },
        {
          field: "vatRate",
          header: t("books.vatRate"),
          style: { minWidth: 100,maxWidth:100 },
          body: (row) =>
            func.getFormattedMoneyValue(row?.vatRate ?? 0),
          align: "right"
        },
        {
          field: "linePriceBefore",
          header: t("books.linePriceBefore"),
          style: { minWidth: 150,maxWidth:150 },
          body: (row) =>
            func.getFormattedMoneyValue(row?.linePriceBefore ?? 0),
          align: "right"
        },
        {
          field: "vatAmount",
          header: t("books.vatAmount"),
          style: { minWidth: 150,maxWidth:150 },
          body: (row) =>
            func.getFormattedMoneyValue(row?.vatAmount ?? 0),
          align: "right"
        },
        {
          field: "",
          header: "",
          style: { width: 2500 },
        },

      ];

      const rowExpansionTemplate = () => {
        const expandedInvoiceData = expanded?.expandedInvoiceData?.data
        if (expanded?.loadingInvoiceData || expanded?.loadingInvoiceItems) return <Loader size="small" />

        return (
        <div className="d-flex flex-column ml-3 mt-3">
            {expandedInvoiceData && <div className="mb-2">
            <h4>{expanded?.expandedInvoiceData?.type == "Corrective" ? t("queue.correctedInvoice") : t("queue.correctiveInvoice")}</h4>
          <PrimeTable
            loading={expanded?.loadingInvoiceData}
            value={expandedInvoiceData ?? []}
            columns={columns}
            showFilters={false}
            paginator={false}
            filterDisplay={false}
            responsiveLayout="scroll"
            selectedColumns={[selectedColumns, setSelectedColumns]}
            showHeader={false}

          >
            <Column style={{width:40}}/>
          </PrimeTable>
        </div>}
        <div className="mb-5" style={{ width: "100vw" }}>
        <h4>Invoice Items</h4>
          <PrimeTable
            value={expanded.invoiceItems}
            loading={expanded?.loadingInvoiceItems}
            columns={expandedColumns}
            showFilters={false}
            paginator={false}
            filterDisplay={false}
            responsiveLayout="scroll"
          />
        </div>
        </div>

        );
      };
      const invoiceItemsOnExpand = (event) => {
        setExpanded((state) => ({ ...state, loadingInvoiceItems: true, expandedRows: [event.data] }))
        mainAxios
          .post("apiEndpoint/search", {
            object: "GetPurchaseInvoiceItems",
            params: {
                invoiceId: event?.data?.id?.toString(),
                invoiceType:event.data.invoiceKey
            },
          })
          .then((res) => {
            setExpanded(state => ({ ...state, loadingInvoiceItems: false }))
            if (res.data.status) {
                setExpanded((state) => ({ ...state, invoiceItems: res?.data?.content }))
            }
          })
        .catch(err => setExpanded(state => ({ ...state, loadingInvoiceItems: false })))

      };
      const correctiveOnExpand = async (event) => {
        const data = event.data
        const params = {}
        let type = null
        if (data.profileId=="P1") {
            params.iicRef = data.iic
            type = "Corrected"
          }
        else if (data.iicRef) {
          params.iic = data.iicRef
          type = "Corrective"
        }

        if (!params.iic && data.profileId!=="P1") return
        setExpanded((state) => ({ ...defaultExpand, loadingInvoiceData: true }))
        const fromDate=data?.dateRef ?moment(data.dateRef).subtract(3,"days").toISOString(): defaultFilters.fromDate
        const toDate=data?.dateRef ?moment(data.dateRef).add(3,"days").toISOString(): defaultFilters.toDate

        const invoices = await getFilteredResults({ data: {fromDate,toDate, params: { ...defaultFilters.params, ...params } }, page: 1, returnData: true })
        if (invoices?.length > 0) {
          setExpanded((state) => ({ ...state, loadingInvoiceData: false, expandedInvoiceData: { data: invoices,type  } }))
        } else {
          setExpanded((state) => ({ ...state, loadingInvoiceData: false, expandedInvoiceData: null })); return
        }
      }

      const onRowExpand = (event) => {
        correctiveOnExpand(event)
        invoiceItemsOnExpand(event)
      };

      const onRowCollapse = (event) => {
        setExpanded(defaultExpand);
    };

    const internalStatusOptions = useMemo(()=>internalStatusOptionsFn(t,statistics),[t,statistics])
    const cisStatusOptions = useMemo(()=>cisStatusOptionsFn(t,statistics),[t,statistics])
    const priorityOptions = useMemo(()=> priorityOptionsFn(t,statistics),[t,statistics])
    const otherOptions = useMemo(()=>otherOptionsFn(t,statistics),[t,statistics])
    const uIOptions = useMemo(()=>uIOptionsFn(t),[t])
    const currencyOptions = useMemo(()=>currencyOptionsFn(statistics),[statistics])


    const approvedPurchases = invoices?.filter(
        (invoice) => invoice?.internalStatus === "Approval"
    );

    let ApprovedPurchaseAmount = 0;

    if (approvedPurchases) {
        approvedPurchases.forEach((invoice) => {
            ApprovedPurchaseAmount = ApprovedPurchaseAmount + invoice.amount;
        });
    }

    const refusedPurchases = invoices?.filter(
        (invoice) => invoice?.internalStatus === "Refused"
    );

    let RefusedPurchaseAmount = 0;

    if (refusedPurchases) {
        refusedPurchases.forEach((invoice) => {
            RefusedPurchaseAmount = RefusedPurchaseAmount + invoice.amount;
        });
    }

    const handleParamsChange = (e, label, val) => {
        const key = e ? e.target.name : label;
        const value = e ? e.target.value : val;
        console.log({key,value})
        if (uIOptions?.map((op) => op.value).includes(key)) {
            setUIType({
                value: key,
                label: uIOptions?.find((op) => op.value == key)?.label,
                uidValue: value,
            });
        } else {
            setFilters((filters) => ({
                ...filters,
                params: {
                    ...filters.params,
                    [key]: value,
                },
            }));
        }
    };

  const loadingIdKey="fic"
  const { showInvoicePdf,pdfEmbed,loadingPdf } = useShowInvoicePdf({loadingIdKey})


    const columns = useGeneratePurchasesColumns({
        dataFrom,
        loadingPdf,
        loadingIdKey,
        showInvoicePdf,
        allTcr,
        cisStatusOptions,
        internalStatusOptions,
        priorityOptions,
        currencyOptions,
        tcrList,
        filters,
        setFilters,
        handleParamsChange,
        getFilteredResults,
        setContactModal,
        checkUnknownBussiness
    });

    const [selectedColumns, setSelectedColumns] = usePersistedState(
        columns.map((col) => ({field:col.field,show:!!col.default,...(col?.persisted?{persisted:true}:{})})),
        "purchasesColumns4"
    );

    const filterStatisticCard=(typeOptions,props)=>globalFilterStatisticCard(typeOptions,{...props,handleParamsChange,getFilteredResults,user,filters})


    const getUnknownBussinessInvoices = async () => {
        setLoading(true)
        mainAxios.post("/endpoint/v2/getSuppliersNotInConnections",{
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            nuis: user.companiesRights.find(
                (company) => company.id === parseInt(selectedCompany)
            )?.nuis,
        }).then(res=>{
            setLoading(false)
            if(res.status==200){
                setInvoices(res.data.content);
            }
        })
        .catch(()=>{
            setLoading(false)
        })
    }

    const onUnknownBussinessChange = () => {
        if(checkUnknownBussiness){
            setCheckUknownBussiness(false)
            setFilters(({...defaultFilters}))
        }else{
            getUnknownBussinessInvoices()
            setCheckUknownBussiness(true)
        }
    }

    const {
        selectedRows:downloadSelectedRows,
        setSelectedRows: setSelectedDownloadRows,
        downloadCheckboxBody,
        downloadMultiFilter,
        downloadButtonsRight,
        actionLoading,
    } = useDownloadPurchInvoices();

    const {
        selectedApproveRows,
        setSelectedApproveRows,
        approveMultiInovicesFilter,
        approveMultiInovicesBody,
        approvePurchaseButtons,
    } = useApprovePurchInvoices({
        invoices,
        user,
        selectedCompany,
        fullCompany,
        allTcr,
        getFilteredResults,
    });

    const {
        setSelectedPaymentOrderRows,
        paymentOrderMultiSelectFilter,
        paymentOrderMultiSelectBody,
        paymentOrderActionButtons,
    } = usePaymentOrderMultiselect({
        invoices,
        selectedCompany,
        user,
    });

    const headerLeft = (
        <>
            {[8, 13, 14].includes(user?.purchaseRole?.id) && (
                <div className="purchases-header-left">
                        <div className="purchases-header-left__check">
                            <PopOver
                                customStyle={{
                                    borderRadius: "40%",
                                    width: "20px",
                                    height: "20px",
                                    transform: "scale(0.80)",
                                    backgroundColor: "#343a40",
                                    color: "white",
                                    marginBottom:"0px !important"
                                }}
                                title={t("purchases.checkSuppliers")}
                            />
                            <div className="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    name="checkUnknownBusiness"
                                    id="checkUnknownBusiness"
                                    className="custom-control-input"
                                    checked={checkUnknownBussiness}
                                    onChange={(e) =>onUnknownBussinessChange()}
                                />
                                <label
                                    htmlFor="checkUnknownBusiness"
                                    className="custom-control-label"
                                    style={{ paddingLeft: "0.5em", paddingTop: "0.2em" }}
                                >
                                    {t("purchases.saveunknown")}
                                </label>
                            </div>
                        </div>

                        <div className="purchases-header-left__actions">
                            <button
                                className="btn btn-sm btn-outline-primary rounded-pill"
                                disabled={loading}
                                onClick={(e) => {
                                    getFilteredResults({ page: tableRows.currentPage, pageSize: 10, dataFromCis: true });
                                }}
                            >
                                <FontAwesomeIcon icon={faSyncAlt} className="mr-1" />
                                <span>{t("purchases.checkNew")}</span>
                            </button>
                            {( user?.role?.id == 1 || user?.purchaseRole?.id ==13) && manualWsEnabled &&
                                <DisableLayout>
                                    <button
                                        className="btn btn-sm btn-primary rounded-pill"
                                        disabled={cisLoading}
                                        onClick={(e) => {
                                            downloadByPeriod({ page: tableRows.currentPage, pageSize: 10, dataFromCis: true });
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            { cisLoading ?
                                                <Preloader use={Oval}
                                                    size={20}
                                                    strokeWidth={2}
                                                    strokeColor="#ffff"
                                                />
                                                :
                                                <FontAwesomeIcon icon={faFile} className="mr-1" />
                                            }
                                            <span>{t("purchases.downloadByPeriod")}</span>
                                        </div>
                                    </button>
                                </DisableLayout>
                            }
                        </div>
                </div>
            )}
        </>
    )


    useEffect(() => {
        setSelectedApproveRows([]);
        setSelectedPaymentOrderRows([]);
    }, [headerCheckboxMode, setSelectedApproveRows, setSelectedPaymentOrderRows,setSelectedDownloadRows]);

    useEffect(() => {
        if (headerCheckboxMode === 'download' && downloadSelectedRows.length > 0) {
            setSelectedDownloadRows([]);
        }
    }, [filters.fromDate, filters.toDate]);

    const getHeaderButtonsRight = () => {
        switch (headerCheckboxMode) {
            case 'download':
                return downloadButtonsRight;
            case 'approve':
                return approvePurchaseButtons;
            case 'payment-order':
                return paymentOrderActionButtons;
            default:
                return null;
        }
    };

    const getCheckboxBody = () => {
        switch (headerCheckboxMode) {
            case 'download':
                return downloadCheckboxBody;
            case 'approve':
                return approveMultiInovicesBody;
            case 'payment-order':
                return paymentOrderMultiSelectBody;
            default:
                return null;
        }
    };

    const getCheckboxFilter = () => {
        switch (headerCheckboxMode) {
            case 'download':
                return () => downloadMultiFilter(invoices);
            case 'approve':
                return approveMultiInovicesFilter;
            case 'payment-order':
                return paymentOrderMultiSelectFilter;
            default:
                return <></>;
        }
    };

    const headerButtonsRight = getHeaderButtonsRight();
    const checkboxBody = getCheckboxBody();
    const checkboxFilter = getCheckboxFilter();

    const typeOptions=[
        {
            key: "isOnlyFisc",
            count: statistics?.onlyFisc,
            label: t("parameters.onlyFiscalization"),
            value: "true",
        },
        {
            key: "isCustom",
            count: statistics?.importCustomNo,
            label: "Deklarate Doganore",
            value: "true",
        },
        {
            key: "isEinvoice",
            count: statistics?.einvoiceNo,
            label: "E-Invoice",
            value: "true",
        },
    ]

    const customDateRanges=
        [
            {
            label: t("common.thisYear"),
            value: 'thisYear',
            onDateChange: () => {
              let startDate = moment().startOf('Y')._d;
              let endDate = moment().endOf('day')._d;
              return [startDate, endDate];
            },
          },
            {
            label: t("common.lastYear"),
            value: 'lastYear',
            onDateChange: () => {
            let startDate = moment().subtract(1, "year").startOf('year').toDate();
            let endDate = moment().subtract(1, "year").endOf('year').toDate();
              return [startDate, endDate];
            },
          },
        ]

    const visibility= useMemo(()=>openBankingVisibility(fullCompany,user),[fullCompany,user])
        

    const functionalityHeaderOptions = useMemo(()=>{
        let options = [
          { value: "none", label: t("invoice.selectOptions") },
          {
            value: "download",
            label: t("invoice.download"),
            info: t("purchases.downloadInfo"),
          },
        ]
        if (visibility.paymentOrder) {
            options.push({
                value:"payment-order",
                label:t("paymentOrder.paymentOrder"),
                info: t("purchases.paymentOrderInfo")
            })
        } 
        if (fullCompany?.groupAction) {
            options.push({
                value:"approve",
                label:t("invoice.approveReject"),
                info: t("purchases.approveRejectInfo")
            })
        }

        return options
    },[visibility.paymentOrder,fullCompany?.groupAction,t])


    const functionalityHeader = (
        <Select
            value={functionalityHeaderOptions.find(opt => opt.value === headerCheckboxMode)}
            onChange={(selectedOption) => setHeaderCheckboxMode(selectedOption?.value || 'none')}
            styles={multiSelectHeaderStyle}
            components={{ Option: SelectOptionWithInfo }}
            className="w-100"
            options={functionalityHeaderOptions}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
        />
    )

    // Export dropdown for headerIcons
    const exportDropdown = (
        <ExportCsvMultiple
            selectedColumns={selectedColumns}
            data={invoicesForCSV}
            columns={columns}
            onClick={() => getFilteredResults({ getInvoicesForCVS: true })}
            excludedColumns={["actions", "print", "activities"]}
            asDropdown={true}
        />
    );

    return  (
        <>
            <Dialog
              header={t("mySuppliers.addContact")}
              visible={contactModal.visible}
              onHide={()=>setContactModal({visible:false,contact:null})}
              style={{ width: "900px",minHeight:"90%" }}
              breakpoints={{ "960px": "80vw", "641px": "100vw" }}
            >
              {contactModal.visible&& <EditAddSupplies
                contact={contactModal?.contact}
                onDataSuccess={(contact)=>{
                  setContactModal({contact:null,visible:false,id:null})
                  setInvoices((invoices)=>{
                    let invoicesCopy=[...invoices]
                    invoicesCopy = invoicesCopy.filter(inv=>inv.id!=contactModal?.invoiceId)
                    return invoicesCopy
                    })
                }}
              />}
            </Dialog>
            <div className="d-flex flex-wrap justify-content-between align-items-center my-1">
                <div className="left-header d-flex align-items-center">
                    <h3 className="mb-0 d-flex align-items-center">
                        {t("navbar.purchases")}{" "}
                    </h3>
                    <AlertCertificate />
                    <AlertSubscription />
                </div>
                <CisMessage transactionType="purchase" />
                <div className="d-flex align-items-center ml-auto">
                    <div className="mr-2">
                        <DateRange
                            fromDate={filters.fromDate}
                            toDate={filters.toDate}
                            customDateRanges={customDateRanges}
                            onChange={(dates) => {
                                let fromDate = dates[0];
                                let toDate = dates[1];
                                setFilters((filters) => ({
                                    ...filters,
                                    fromDate,
                                    toDate,
                                }));
                            }}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{minWidth: "140px"}}>
                        <label className="align-items-center mr-2 mb-0">BU</label>
                        <Select
                            styles={selectStyle}
                            className="w-100"
                            options={businessUnitCodes}
                            value={
                                persistedData?.businessUnitCode
                                    ? businessUnitCodes.find(
                                        (businessUnit) =>
                                            businessUnit.value === businessUnitSelected
                                    )
                                    : { label: t("invoice.businessUnitCode"), value: "" }
                            }
                            isSearchable={true}
                            onChange={(bu) => {
                                handleParamsChange(null, "purchaseUnit", []);
                                setPersistedData({
                                    ...persistedData,
                                    businessUnitCode: bu.value,
                                });
                                let buReset = bu.value ? false : true // needed because setState is async
                                let purchaseUnits = bu.value ? tcrList(bu.value, false).map((tcr) => tcr.value) : []
                                getFilteredResults({
                                    data: {
                                        ...filters,
                                        params: {
                                            ...filters.params,
                                            purchaseUnit: purchaseUnits,
                                        },
                                    }, buReset
                                });
                            }}
                            name="purchaseUnit"
                        />
                    </div>
                </div>
            </div>
            <div className="filter-cards-container d-none d-md-block">
                <div className="filter-cards-header">
                    <button
                        className={`filter-cards-toggle ${filtersCollapsed ? 'filter-cards-toggle--collapsed' : ''}`}
                        onClick={() => setFiltersCollapsed(!filtersCollapsed)}
                    >
                        <FontAwesomeIcon icon={faFilter} />
                        {filtersCollapsed ? (t("common.showFilters", "Show Filters")) : (t("common.hideFilters", "Hide Filters"))}
                        {filterCount > 0 && <span className="badge badge-primary ml-1">{filterCount}</span>}
                        <FontAwesomeIcon icon={faChevronUp} />
                    </button>
                </div>
                <div className={`filter-cards-row ${filtersCollapsed ? 'filter-cards-row--collapsed' : ''}`}>
                    <div className="filter-card-col">
                        {filterStatisticCard(cisStatusOptions, {
                            title: t("purchases.cisStatus"),
                            cardClasses: "stats-cols-2",
                        })}
                    </div>
                    <div className="filter-card-col">
                        {filterStatisticCard(internalStatusOptions, {
                            title: t("purchases.inProcess"),
                            cardClasses: "stats-cols-2",
                        })}
                    </div>
                    <div className="filter-card-col">
                        {filterStatisticCard(typeOptions, {
                            title: t("invoice.type"),
                            cardClasses: "stats-cols-1",
                        })}
                    </div>
                    <div className="filter-card-col">
                        {filterStatisticCard(currencyOptions, {
                            cardClasses: "stats-cols-1",
                            title: t("invoice.currency"),
                        })}
                    </div>
                    <div className="filter-card-col">
                        {filterStatisticCard(otherOptions, {
                            cardClasses: "stats-cols-1",
                            title: t("invoice.other"),
                        })}
                    </div>
                </div>
            </div>
            <div>
                    <PrimeTable
                        loading={loading || !fullCompany || actionLoading}
                        showFilters={true}
                        reorderableColumns={true}
                        filters={[filters, setFilters]}
                        likeValues={filterLikeValues}
                        defaultFilters={defaultFilters}
                        tableRows={[tableRows, setTableRows]}
                        persistedRowPerPage={[persistedRowPerPage, setPersistedRowPerPage]}
                        value={invoices ?? []}
                        gridKey="purchasesColumns4"
                        selectedColumns={[selectedColumns, setSelectedColumns]}
                        columns={columns}
                        dataKey="id"
                        onRemoteDataChange={(remoteData) => {
                            const updatedFilters = remoteData.filters ?? filters
                            const updatedTableData = remoteData.tableRows ?? tableRows
                            let { currentPage, rowsPerPage,sortCriteria } = updatedTableData
                            sortCriteria=sortCriteria?[sortCriteria]:[]
                            getFilteredResults({ data: updatedFilters, pageSize: rowsPerPage, page: currentPage,sortCriteria })
                        }}
                        expandedRows={expanded.expandedRows}
                        onRowCollapse={onRowCollapse}
                        onRowExpand={onRowExpand}
                        rowExpansionTemplate={rowExpansionTemplate}
                        headerButtonsRight={headerButtonsRight}
                        headerButtonsLeft={headerLeft}
                        headerIcons={exportDropdown}
                        columnDeps={[fullCompany, invoices?.length,loadingPdf,contactModal,checkUnknownBussiness]}//when should the colums should be rerendered,invoices length is needed because of thermal print
                        defaultSortCriteria={defaultSortCriteria}
                        parseFilterValue={false}
                        simpleTable={checkUnknownBussiness}
                        mobileExpansionLabel={t("invoice.invoiceItems", "Invoice Items")}
                        mobileFilterContent={
                            <div className="filter-cards-row">
                                <div className="filter-card-col">
                                    {filterStatisticCard(cisStatusOptions, {
                                        title: t("purchases.cisStatus"),
                                        cardClasses: "stats-cols-2",
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(internalStatusOptions, {
                                        title: t("purchases.inProcess"),
                                        cardClasses: "stats-cols-2",
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(typeOptions, {
                                        title: t("invoice.type"),
                                        cardClasses: "stats-cols-1",
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(currencyOptions, {
                                        cardClasses: "stats-cols-1",
                                        title: t("invoice.currency"),
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(otherOptions, {
                                        cardClasses: "stats-cols-1",
                                        title: t("invoice.other"),
                                    })}
                                </div>
                            </div>
                        }
                    >
                        <Column
                            filter={true}
                            header={functionalityHeader}
                            showFilterMenu={false}
                            showClearButton={false}
                            filterElement={checkboxFilter}
                            body={checkboxBody}
                            headerStyle={{ minWidth:"105px",maxWidth:"105px", padding:"0",paddingLeft:"5px" }} frozen
                       />
                        <Column
                            expander={() => true}
                            style={{ minWidth: 40, maxWidth: 100 }}
                            header=""
                            field="expansion"
                            frozen={true}/>
                    </PrimeTable>
            </div>
            {pdfEmbed}
        </>
    ) 
};

export default PurchasesNew;
